import React from 'react';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';

interface DropZoneProps {
  onDrop: (files: File[]) => void;
}

const DropZone: React.FC<DropZoneProps> = ({ onDrop }) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <Wrapper {...getRootProps()} isDragActive={isDragActive}>
      <input {...getInputProps()} />
      <p>
        {isDragActive
          ? '여기에 파일을 놓으면 업로드됩니다!'
          : '파일을 여기에 드래그하거나 클릭하여 선택하세요'}
      </p>
    </Wrapper>
  );
};

const Wrapper = styled.div<{ isDragActive: boolean }>`
  cursor: pointer;
  width: 100%;
  height: 100%;
  border: 1px solid ${(props) => (props.isDragActive ? '#2196f3' : '#ccc')};
  padding: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  margin-bottom: 20px;
  background-color: ${(props) => (props.isDragActive ? '#e1f5fe' : 'white')};
  transition: all 0.3s ease;
`;

export default DropZone;
